import React, { useEffect, useState } from 'react';
import Preloader from '../elements/Preloader';
import HelmetReact from '../elements/HelmetReact';
import Breadcrumb from '../components/Breadcrumb';
import FooterThree from '../components/FooterThree';
import Newsletter from '../components/Newsletter';
import BlogAreaAll from '../components/BlogAreaAll';
import HeaderThree from '../components/HeaderThree';

const Blog = () => {
    let [active, setActive] = useState(true);
    useEffect(() => {
        setTimeout(function() {
            setActive(false);
        }, 500);
    }, []);
    return (
        <>
            {/* Preloader */}
            {active === true && <Preloader/>}

            {/* Helmet */}
            <HelmetReact title={'Blog'}/>

            {/* HeaderThree */}
            <HeaderThree/>

            {/* Breadcrumb */}
            <Breadcrumb title="Blog"/>

            {/* BlogAreaAll */}
            <BlogAreaAll/>

            {/* Newsletter */}
            {/*<Newsletter />*/}

            {/* FooterThree */}
            <FooterThree/>

        </>
    );
};

export default Blog;
